import { BREAK_POINT_SCREEN_SM } from '@client/config/constants';

const DEFAULT_DEVICE_WIDTH = 1200;
const DEFAULT_DEVICE_HEIGHT = 600;

export const getClientDevice = state => state.clientDevice;
export const getClientDeviceWidth = (state) => (state.clientDevice ? state.clientDevice.width : DEFAULT_DEVICE_WIDTH);
export const getClientDeviceHeight = (state) => (state.clientDevice ? state.clientDevice.height : DEFAULT_DEVICE_HEIGHT);
export const getClientDeviceOffsetTop = state => state.clientDevice.offsetTop;
export const getWebviewOs = state => state.clientDevice.webviewOs;
export const getIsMobileScreen = state => getClientDeviceWidth(state) < BREAK_POINT_SCREEN_SM;
export const getTabVisible = state => state.clientDevice.tabVisible;
